module.exports = __webpack_public_path__ + "img/main_story_l720.c3a60a49.png";